var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMoreOptions(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.16667 12.2918C2.9 12.2918 1.875 11.2668 1.875 10.0002C1.875 8.7335 2.9 7.7085 4.16667 7.7085C5.43333 7.7085 6.45833 8.7335 6.45833 10.0002C6.45833 11.2668 5.43333 12.2918 4.16667 12.2918ZM4.16667 8.9585C3.59167 8.9585 3.125 9.42516 3.125 10.0002C3.125 10.5752 3.59167 11.0418 4.16667 11.0418C4.74167 11.0418 5.20833 10.5752 5.20833 10.0002C5.20833 9.42516 4.74167 8.9585 4.16667 8.9585Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8332 12.2918C14.5665 12.2918 13.5415 11.2668 13.5415 10.0002C13.5415 8.7335 14.5665 7.7085 15.8332 7.7085C17.0998 7.7085 18.1248 8.7335 18.1248 10.0002C18.1248 11.2668 17.0998 12.2918 15.8332 12.2918ZM15.8332 8.9585C15.2582 8.9585 14.7915 9.42516 14.7915 10.0002C14.7915 10.5752 15.2582 11.0418 15.8332 11.0418C16.4082 11.0418 16.8748 10.5752 16.8748 10.0002C16.8748 9.42516 16.4082 8.9585 15.8332 8.9585Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0002 12.2918C8.7335 12.2918 7.7085 11.2668 7.7085 10.0002C7.7085 8.7335 8.7335 7.7085 10.0002 7.7085C11.2668 7.7085 12.2918 8.7335 12.2918 10.0002C12.2918 11.2668 11.2668 12.2918 10.0002 12.2918ZM10.0002 8.9585C9.42516 8.9585 8.9585 9.42516 8.9585 10.0002C8.9585 10.5752 9.42516 11.0418 10.0002 11.0418C10.5752 11.0418 11.0418 10.5752 11.0418 10.0002C11.0418 9.42516 10.5752 8.9585 10.0002 8.9585Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoreOptions);
export default __webpack_public_path__ + "static/media/more-options.0f60787b8f48758fa435c07bbf4a4aef.svg";
export { ForwardRef as ReactComponent };